import {
  ISignupAccount, ISignupApprovals,
  ISignupCredential,
  ISignupLegalEntity,
  ISignupPersonnalInformation,
  ISignupPhone,
} from '@app/models/signup';

export class UpdateLegalEntity {
    static readonly type = '[ITEM] Update Legal Entity';

    constructor(public legalEntity: ISignupLegalEntity) { }
}

export class UpdatePersonnalInformation {
    static readonly type = '[ITEM] Update Personnal Information';

    constructor(public personnalInformation: ISignupPersonnalInformation) { }
}

export class UpdatePhone {
    static readonly type = '[ITEM] Update Phone';

    constructor(public personnalInformation: ISignupPhone) { }
}

export class UpdateAccount {
    static readonly type = '[ITEM] Update Account';

    constructor(public account: ISignupAccount) { }
}

export class UpdateCredential {
    static readonly type = '[ITEM] Update Credential';

    constructor(public credential: ISignupCredential) { }
}

export class UpdateApprovals {
  static readonly type = '[ITEM] Update Approvals';

  constructor(public approvals: ISignupApprovals) { }
}
